import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import AppHeader from '@divvy-web/skylab.appheader'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import GetToKnowYouForm from './GetToKnowYouForm'
import GetToKnowYouMarketingContent from './GetToKnowYouMarketingContent'
import styles from './styles.module.scss'

const GetToKnowYouPage = () => {
  const [getClassName] = useNameFormatter('GetToKnowYouPage')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('wrapper')]}>
        <BillBrandLogo />
        <div className={styles[getClassName('content')]}>
          <div className={styles[getClassName('content-container')]}>
            <AppHeader
              subtitle={
                <div className={styles[getClassName('subtitle')]}>
                  <FormattedMessage
                    defaultMessage='Provide your information here. You can tell us about others in your company later'
                    id='sputnik.GetToKnowYouPage__9fi4iu'
                  />
                </div>
              }
            >
              <h1>
                <FormattedMessage
                  defaultMessage='Let’s get to know you better'
                  id='sputnik.GetToKnowYouPage__bP/49w'
                />
              </h1>
            </AppHeader>
            <GoogleReCaptchaProvider
              useEnterprise
              reCaptchaKey={window.__DivvyEnvironment.GOOGLE_RECAPTCHA_SITE_KEY ?? ''}
              scriptProps={{ appendTo: 'body', defer: true }}
            >
              <GetToKnowYouForm />
            </GoogleReCaptchaProvider>
          </div>
        </div>
      </div>
      <GetToKnowYouMarketingContent />
    </div>
  )
}

export default GetToKnowYouPage
